import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef, AfterContentChecked } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { CustomValidators } from 'ng2-validation';
import { StageSandbox } from '../../services/stage.sandbox';

import * as stageTypes from '../../types';
import { Observable } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';

import * as jsonTest from '../formDefinitions.json';
import { IProcessedData } from '../../../shared/types';
import { FormlyManipulation } from '../../../shared/helpers/generateFormlyData';

import * as _ from 'lodash';
import { AnimationBuilder, AnimationPlayer, useAnimation } from '@angular/animations';
import * as animations from '../../../shared/animations';
import { PopNotificationService } from '../../../shared/services/pop-notification.service';

import { BlockUIService } from 'ng-block-ui';

@Component({
  selector: 'tr-personal-detail-container',
  templateUrl: './personal-detail-container.component.html',
  //styleUrls: ['./personal-detail-container.component.scss']
})
export class PersonalDetailContainerComponent implements OnChanges, OnInit, OnDestroy {

  @Input() entity: stageTypes.IPage;

  private personalDetailForm: FormGroup; // Form
  private personalDetailModel = {};
  private pageFields: FormlyFieldConfig[] = []; // Form Config
  private pageName: string;

  private currentPageId$: Observable<number> = this.sb.getCurrentPageId$();
  private pagesLength$: Observable<number> = this.sb.getCurrentStagePageLength$();
  private subscriptions: Array<Subscription> = [];

  private formData: IProcessedData;
  private formOptions: any;

  private updatedFileInfo:any = {};

  private blockUI_target = 'stage-section';

  // animations
  @ViewChild('formDataSection') formDataSection: ElementRef;
  @ViewChild('navButtons') navButtons: ElementRef;

  private effect: string;
  private player: AnimationPlayer;

  constructor(
    private cdRef: ChangeDetectorRef,
    private formlySvc: FormlyManipulation,
    private fb: FormBuilder,
    private sb: StageSandbox,
    private builder: AnimationBuilder,
    private notificationSvc: PopNotificationService,
    private blockUI: BlockUIService
  ) {}

  onNavigatePage($event) {
    if (this.personalDetailForm.invalid && !$event.isDraft) {
      _.forEach(this.personalDetailForm.controls, (value, key) => {
        if (value.errors) {
          value.markAsTouched();
        }
      });
      this.showingErrors('', 'You haven\'t completed all fields correctly. Please refer to the error messages on the screen.');

    } else {
      //Siddharth ADO-136687, Added the below block-ui code. This block-ui will be stopped in stage.effects.ts page
      this.blockUI.start(this.blockUI_target, 'Saving data.....');

      let _model = _.pickBy(this.getPageModel(), (val, key) => (_.isArray(val)) ?  val.length > 0 : !_.isNil(val) );
      if ($event.isDraft) {
        _model = Object.assign({}, _model, { draft: 1 });
      }

      this.effect = this.sb.navigatePage($event.nextPage,
        _model,
        this.personalDetailForm.dirty,
        this.personalDetailForm.valid,
        this.updatedFileInfo[this.pageName],
        this.updateQuestionValue.bind(this),
        this.showingErrors.bind(this)
      );

      // reset form status
      this.personalDetailForm.markAsPristine();
    }
  }

  showingErrors(title: string, body: string) {
    this.notificationSvc.popNotification({
      type: 'error',
      title: title,
      body: body
    });
  }

  private massageAttachmentData(data) {


    if (_.has(data, 'oldFiles')) {
      const oldFiles = _.cloneDeep(data.oldFiles);
      data = _.omitBy(_.omit(data, 'oldFiles'), _.isNil);
      _.forEach(oldFiles, function(value, key) {
        const fileNames: string[] = _.isArray(data[key]) ? data[key] : [data[key]];
        (_.isArray(value) ? value : [value]).map( oldFileName => {
          if (_.indexOf(fileNames, oldFileName) > -1) {
            _.pull(fileNames, oldFileName);
          }
        });
      });

      return _.pickBy(data, (val, key) => (_.isArray(val)) ?  val.length !== undefined && val.length > 0 : !_.isNil(val) );

    }

    return _.omitBy(data, _.isNil);
  }

  private massageData(data) {
    return _.transform(data, (result, value, key) => {
      // ignore key which is in format of "group-x"
      // value is an array of 1 object
      _.merge(result, _.pickBy(value[0], (val, key) => (_.isArray(val)) ? val.length > 0 : !_.isNil(val) ));
    }, {});
  }
  submit() {

  }

  getPageModel() {
    if (!_.has(this.personalDetailModel, this.pageName)) {
      this.personalDetailModel[this.pageName] = this.formData.model;
      this.updatedFileInfo[this.pageName] = {};
      return this.formData.model;
    } else {
      return this.personalDetailModel[this.pageName];
    }
  }

  updateQuestionValue(questionId, value, answerIndex?) {
    if (_.isNil(answerIndex)) {
      this.personalDetailModel[this.pageName][questionId] = value;
    } else {
      this.personalDetailModel[this.pageName][questionId][answerIndex] = value;
    }
  }

  processFileInfo (configDef: FormlyFieldConfig[]): FormlyFieldConfig[] {
    //console.log(this.updatedFileInfo);
    let pageFileInfo = this.updatedFileInfo[this.pageName];
    configDef[0].fieldGroup.map( (field) =>
      field.fieldGroup.map( subField => {
        if (_.has(pageFileInfo, subField.key) && ((subField.type === 'file') || (subField.type === 'files'))) {
          // trying to fix the "length of undefined error", when go previous page on questions with attachments, not sure how to handle it
          //console.log("processFileInfo()");
          //console.log(subField.templateOptions);
          if (subField.templateOptions.fileInfo === undefined || (subField.templateOptions.fileInfo !== undefined && subField.templateOptions.fileInfo.length == 0) ) {
            subField.templateOptions.fileInfo = [];
          }
          _.forEach(pageFileInfo[subField.key], (value, key) => {
            subField.templateOptions.fileInfo.push(value);
          });
        }
      })
    );

    return configDef;
  }

  // lifecycles
  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach(sub => sub.unsubscribe());
    //this.sb.onComponentDestroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pageName = this.entity.name;
    this.personalDetailForm = this.fb.group({});
    this.formData = this.formlySvc.process(this.entity);
    this.pageFields = this.processFileInfo(this.formData.config);
    this.formOptions = {
      uploader: this.sb.getUploader(),
      sandbox: this.sb,
      formState: {
        model: this.formData.model
      }
    };

    if (this.effect) {
      this.applyAnimation();
    }

    window.scrollTo(0, 0);
    this.cdRef.detectChanges();
  }

  applyAnimation() {
    setTimeout(() => {
      const factory = this.builder.build([
        useAnimation(animations.slideAnimation, {
          params: {
            from: '100%', // using if need fadeIndown when Previous is clicked and fadeInUp when Next is clicked  (this.effect === 'fadeInDown') ? '-100%' : '100%',
            to: '0'
          }
        })
      ]);

      this.player = factory.create(this.formDataSection.nativeElement, {});
      this.player.play();
    });
  }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/stage/containers/personal-detail-container/personal-detail-container.component.ts